import { Grid, Typography } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { getCollectionData } from "../Category/API/api";
import { Card } from "components/ui";
import { useGlobalContext } from "context/GlobalContext";
import { useNavigate, useParams } from "react-router-dom";
import SortContext from "context/SortContext";
import LoadingSmallCard from "components/ui/Skeleton/LoadingSmallCard";
import { useGetPurchaseCollection } from "./API/api";

function CollectionPurchase() {
  const { clientId } = useParams();
  const [collections, setCollections] = useState([]);
  let navigate = useNavigate();
  const { setFilterChangeCount, setDisplayCount, setFilterChangeDesignCount, setSearchResultCount, setSearchSuffix, dynamicfilterCount, filterChangeCount, filterChangeDesignCount } =
    useGlobalContext();

  const { setSortOptions } = useContext(SortContext);

  //API
  let payload = {
    clientCode: clientId,
  };

  const { data, isLoading, error } = useGetPurchaseCollection(payload);

  useEffect(() => {
    if (data) {
      setCollections(data?.data || []);
    }
  }, [data]);

  useEffect(() => {
    if (dynamicfilterCount) {
      setFilterChangeCount(data?.totalCount || 0);
      setFilterChangeDesignCount(data?.totalDesignCount || 0)
      setSearchResultCount(0);
    } else {
      setSearchResultCount(0);
      setFilterChangeCount(filterChangeCount);
      setFilterChangeDesignCount(data?.totalDesignCount || 0)
    }
    setDisplayCount(true);
    setSearchSuffix("Designs");

    return () => {
      setSearchResultCount(0);
      setFilterChangeCount(0);
      setFilterChangeDesignCount(0);
      setDisplayCount(false);
      setSearchSuffix("");
    };
  }, [collections]);

  useEffect(() => {
    setSortOptions(["d", "e", "f"]);
    return () => {
      setSortOptions([]);
    };
  }, []);

  const handleCollectionClick = (collectionName) => {
    navigate(`${encodeURIComponent(collectionName)}`);
  };

  if (isLoading) {
    return <LoadingSmallCard count={20} />;
  }

  if (error) {
    return <p>Error</p>;
  }

  return (
    <div style={{ color: "yellow" }}>
      <Grid
        container
        className="Grid-padding"
        direction="row"
        sx={{ flex: "1 1 1", display: "flex", alignItems: "center", justifyContent: "flex-start", gap: "30px", rowGap: "32px", maxHeight: "85vh", overflow: "auto", scrollbarWidth: "none" }}
      >
        {collections?.map((collection) => {
          return (
            <Grid item onClick={() => handleCollectionClick(collection.collectionName)}>
              <Card
                style={{
                  minWidth: "290px",
                  maxWidth: "290px",
                  height: 62,
                  borderRadius: "5px",
                  position: "relative",
                  overflow: "hidden",
                }}
              >
                <Typography mr={"auto"} fontSize={"20px"} fontWeight={400} fontFamily={"Karla"}>
                  {collection.collectionName}
                </Typography>
                <Typography ml={"auto"} fontSize={"20px"} fontWeight={400} fontFamily={"Karla"}>
                  {collection.count}
                </Typography>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </div>
  );
}

export default CollectionPurchase;
